import React, { useState } from 'react'
import './NavBarStyle.css'
import { FaBars, FaTimes } from 'react-icons/fa'
import { Link } from 'react-scroll'
const NavBar = () => {
    const [nav, setNav] = useState(false);
    const handleClick = () => setNav(!nav)

  return (
    <>
      
    <section className="mainhead">
       <div className="logo">
       <h1>Bilal.div</h1>
       {/* <a href="/"> <h1>Bilal.div</h1></a> */}
    </div> 
          <ul id= 'navbar'>
                <li><Link to="/" className="active">Home</Link></li>
                <li><Link to="about" spy={true} smooth={true} offset={50} duration={500}>About</Link></li>
                <li><Link to="project" spy={true} smooth={true} offset={50} duration={600} >Project</Link></li>
                <li><Link to="contact" spy={true} smooth={true} offset={50} duration={1200}>Contact</Link></li>
                <a href='./Images/Muhammad Bilal.pdf' className='resume' target='-blank'>Resume</a>
            </ul>
            <div className='hamburger' >
           <a href='./Images/Muhammad Bilal.pdf' className='resume' target='-blank'>Resume</a>
              {!nav ? <FaBars size={30} style={{ color: 'black' }} onClick={handleClick} /> :
                <FaTimes size={30} style={{ color: 'black' }} onClick={handleClick} /> }

                </div>
                <div className={nav ? 'mobile-menu active' : 'mobile-menu'}>
                <ul className='nav'>
                <li><Link to="/" className="active" onClick={handleClick}>Home</Link></li>
                <li><Link to="about" spy={true} smooth={true} offset={50} duration={500} onClick={handleClick}>About</Link></li>
                <li><Link to="project" spy={true} smooth={true} offset={50} duration={600} onClick={handleClick}>Project</Link></li>
                <li><Link to="contact" spy={true} smooth={true} offset={50} duration={1200} onClick={handleClick}>Contact</Link></li>
                </ul>
            </div>
    </section>
   </>
  )
}

export default NavBar
